import { PrimaryButton } from "components/designV2/buttons/primaryButton";
import { SecondaryButton } from "components/designV2/buttons/secondaryButton";
import { Modal } from "components/designV2/modal/modal";
import { useTranslation } from "react-i18next";
import type { TeamPublicApplicationModalState } from "./teamPublicDetailsModal.contract";
import { MotivationalLetterModalText } from "./teamPublicDetailsModal.styled";
import { DetailsMessage } from "../shiftDetailsModal.styled";

interface ApplicationActionModalCopy {
  title: string;
  body: string;
  confirmLabel: string;
}

interface TeamPublicDetailsModalDialogsProps {
  isMotivationalLetterModalOpen: boolean;
  selectedMotivationalLetter: string;
  onCloseMotivationalLetterModal: () => void;
  applicationModalState: TeamPublicApplicationModalState;
  applicationActionModalCopy: ApplicationActionModalCopy | null;
  isApplicationActionLoading: boolean;
  onCloseApplicationActionModal: () => void;
  onConfirmApplicationAction: () => Promise<void>;
  onCloseApplicationErrorModal: () => void;
}

export const TeamPublicDetailsModalDialogs: React.FC<
  TeamPublicDetailsModalDialogsProps
> = (props) => {
  const { t } = useTranslation();
  const isConfirmModalOpen =
    props.applicationModalState.type === "confirm" &&
    props.applicationActionModalCopy != null;

  const confirmFooter = (
    <>
      <SecondaryButton
        label={t("General.Cancel")}
        onClick={props.onCloseApplicationActionModal}
        disabled={props.isApplicationActionLoading}
      />
      <PrimaryButton
        label={
          props.applicationActionModalCopy?.confirmLabel ?? t("General.Confirm")
        }
        onClick={props.onConfirmApplicationAction}
        isLoading={props.isApplicationActionLoading}
      />
    </>
  );

  const errorFooter = (
    <PrimaryButton
      label={t("General.Confirm")}
      onClick={props.onCloseApplicationErrorModal}
    />
  );

  return (
    <>
      <Modal
        label={t("Schedule.TeamPublicMotivationalLetter")}
        isOpen={props.isMotivationalLetterModalOpen}
        onClose={props.onCloseMotivationalLetterModal}
        size="small"
        allowContentOverflow
      >
        <MotivationalLetterModalText>
          {props.selectedMotivationalLetter || "-"}
        </MotivationalLetterModalText>
      </Modal>
      <Modal
        label={props.applicationActionModalCopy?.title ?? t("General.Confirm")}
        isOpen={isConfirmModalOpen}
        onClose={props.onCloseApplicationActionModal}
        size="small"
        footer={confirmFooter}
      >
        <DetailsMessage>
          {props.applicationActionModalCopy?.body ?? "-"}
        </DetailsMessage>
      </Modal>
      <Modal
        label={t("Schedule.TeamPublicApplicationActionErrorTitle")}
        isOpen={props.applicationModalState.type === "error"}
        onClose={props.onCloseApplicationErrorModal}
        size="small"
        footer={errorFooter}
      >
        <DetailsMessage>
          {t("Schedule.TeamPublicApplicationActionErrorBody")}
        </DetailsMessage>
      </Modal>
    </>
  );
};
